import { render, staticRenderFns } from "./ProductBasalamSetting.vue?vue&type=template&id=2a3a6c98&scoped=true"
import script from "./ProductBasalamSetting.vue?vue&type=script&lang=js"
export * from "./ProductBasalamSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a6c98",
  null
  
)

export default component.exports